// Entry point for the build script in your package.json

// Helpers (loaded first to make globals available)
import './helpers';

// Libraries (expose globals on window)
import './lib/rails';
import './lib/jquery';
import './lib/select2';
import './lib/bootstrap';
import './lib/toastr';
import './lib/n2words.js';
// select2 loaded via vendor script (needs jQuery global)
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import './lib/sweetalert2';
import './sweet_alert/subscription_confirmation_modal';
import 'intl-tel-input/build/js/intlTelInput-jquery.min';
import 'intl-tel-input/build/js/utils';
import './lib/nouislider'
import './lib/chart';

// App modules (shared across all pages)
import './cable';
import './fixed_header';
import './autocomplete_address';
import './password_confirmation';
import './mobile_profile_nav';
import './projects';
import './redactor_table_custom';
import './registration_default_language';
import './slick/home_carousel'
import './select2';

// Page modules (with guards - only run when relevant elements exist)
import './dashboard_charts';
import './profile';
import './file_field';
import './hide_show_password';
import './suitability_questionnaire';
import './sponsorship';
import './taxation';
import './filters';
import './payin';
import './subscription_expiration';

// STIMULUS
import './controllers';

$(document).ready(function () {
  $('.auto-input').on('change', function () {
    var form = $(this).parents('form')[0];

    Rails.fire(form, 'submit');
  })

  $('.datepicker').datepicker({
    format: 'dd/mm/yyyy',
  });

  if ($("#termsModal").length > 0) {
    $("#termsModal").modal("show");
  }

  if ($("#acceptRegistrationModal").length > 0) {
    $("#acceptRegistrationModal").modal("show");
  }

  if ($('#scaConsentModal').length > 0) {
    $('#scaConsentModal').modal('show');
  }

  if ($('#scaConsentCallbackModal').length > 0) {
    $('#scaConsentCallbackModal').modal('show');
  }

  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })

  $(document).on('shown.bs.collapse', function (event) {
    if (!event.target.classList.contains('no-scroll')) {
      event.target.scrollIntoView({
        behavior: 'smooth',
      });
    }
  });
})
